<template>
  <main class="md:container">
    <!-- Grid -->
    <base-grid :cols="{ sm: 1, md: 2 }" gap-x="sm">
      <template v-for="({ ctas, gridCol }, key) in grid" :key>
        <div
          v-if="eSpots?.[key]?.items"
          v-style:grid-col="gridCol"
          class="mb-8"
        >
          <!-- Core-Media Espot -->
          <lazy-cms-section :section="eSpots?.[key]" />
          <!-- Buttons wrapper for spacing -->
          <div v-if="ctas?.length" class="mt-4 text-center">
            <!-- Button Groups -->
            <div
              v-for="(btnGroup, keyBtnGroup) in getBtnGroups(ctas)"
              :key="keyBtnGroup"
              class="md:i-block"
            >
              <vf-button
                v-for="({ title, to }, keyBtn) in btnGroup"
                :key="keyBtn"
                class="m-1 text-xs"
                size="tiny"
                style="width: 8rem"
                :to
              >
                {{ title }}
              </vf-button>
            </div>
          </div>
        </div>
      </template>
    </base-grid>
  </main>
</template>

<script lang="ts" setup>
const eSpots = (await useCms().getSections.generic('outlet')).data.value?.content?.sections
const { data, error } = await useApi().internal.getStaticPage('outlet')
if (!data.value) throw createError({ ...error.value!, fatal: true })

const { grid } = data.value

const getBtnGroups = (buttons) =>
  buttons.reduce((result, _, index) =>
    index % 2 === 0 ? [...result, buttons.slice(index, index + 2)] : result, [])
</script>
